import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3da77bcc"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "name" }
const _hoisted_4 = { class: "time" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" ~ ")
const _hoisted_6 = {
  key: 0,
  class: "tag tag-expired"
}
const _hoisted_7 = {
  key: 1,
  class: "tag tag-new"
}

import { ICoupon } from '@/types/coupon';
  import { useI18n } from 'vue-i18n';

  interface IProps {
    coupon: ICoupon;
  }

  
export default /*#__PURE__*/_defineComponent({
  props: {
    coupon: null
  },
  setup(__props: any) {

  const { t } = useI18n();

  


return (_ctx: any,_cache: any) => {
  const _component_AppTimeFormat = _resolveComponent("AppTimeFormat")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_component_router_link, {
    class: "card-coupon",
    to: { name: 'mine.coupon', params: { id: __props.coupon.id } }
  }, {
    default: _withCtx(() => [
      _createElementVNode("img", {
        src: __props.coupon.oc_coupon_template.image?.url,
        class: "img"
      }, null, 8, _hoisted_1),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("span", _hoisted_3, _toDisplayString(__props.coupon.oc_coupon_template.name), 1),
        _createElementVNode("span", _hoisted_4, [
          _createTextVNode(_toDisplayString(_unref(t)('available_time')) + ": ", 1),
          _createVNode(_component_AppTimeFormat, {
            time: __props.coupon.started_at,
            format: "YYYY-MM-DD"
          }, null, 8, ["time"]),
          _hoisted_5,
          _createVNode(_component_AppTimeFormat, {
            time: __props.coupon.ended_at,
            format: "YYYY-MM-DD"
          }, null, 8, ["time"])
        ])
      ]),
      (__props.coupon.expired)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, " Expired "))
        : (!__props.coupon.is_read)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, " NEW "))
          : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["to"]))
}
}

})